ko.bindingHandlers["firstChildClass"] =
   init: (element, valueAccessor) ->
      accessor = ko.unwrap(valueAccessor())
      childClass = ko.unwrap(accessor.childClass)
      classToAdd = ko.unwrap(accessor.classToAdd)
      $(element).children(".#{childClass}").first().addClass(classToAdd)